<template>
  <div>
    <van-tabbar v-model="active" class="tab" style="z-index:999;" active-color="#c1443d" route>
      <van-tabbar-item icon="wap-home-o" to="/school">首页</van-tabbar-item>
      <van-tabbar-item icon="apps-o" to="/schoollist">找课</van-tabbar-item>
      <van-tabbar-item icon="user-o" to="/schoolInfo">学习中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
  export default {
  data() {
    return {
      active: 0,
    };
  },
  watch: {
    $route(to) {
      switch (to.fullPath) {
        case '/school':
          this.active = 0;
          break;
        case '/schoollist':
          this.active = 1;
          break;
        case '/schoolinfo':
          this.active = 2;
          break;
        default:
          this.active = 0;
      }
    }
  }
};
</script>

<style scoped>
</style>
